import React, { createContext, useState } from "react";

export const GlobalContext = createContext();

const GlobalContextProvider = (props) => {
  const [show, setShow] = useState(false);
  return (
    <GlobalContext.Provider
      value={{
        show,
        setShow,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
